<template>
    <div id="translateOutput">
        <h2>{{translatedText}}</h2>
    </div>
</template>

<script>
export default {
    name: 'translateOutput',
    props: ['translatedText'],
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/TranslateOutput.vue